export const Centos = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <path
      d="M107.86 118.641l9.229 9.177-9.229 9.175H42.901v30.571L3.286 127.818l39.615-39.08v29.903h64.96zm28.554-78.068h78.929v78.93h-78.929v-78.93z"
      fill="#000"
    />
    <path
      d="M137.275 107.86l-9.175 9.229-9.175-9.229V42.901H88.352L128.1 3.286l39.077 39.615h-29.902v64.96zm-.86 28.554h78.928v78.93h-78.929v-78.93z"
      fill="#000"
    />
    <path
      d="M148.057 137.275l-9.23-9.175 9.23-9.175h64.958V88.352l39.617 39.748-39.617 39.077v-29.902h-64.958zm-107.484-.86h78.929v78.93H40.573v-78.93z"
      fill="#000"
    />
    <path
      d="M118.641 148.057l9.175-9.23 9.177 9.23v64.96h30.571l-39.748 39.615-39.076-39.615h29.901v-64.96zM40.573 40.573h78.929v78.93H40.573v-78.93z"
      fill="#000"
    />
    <path
      d="M37.754 37.754h84.567v84.567H37.754V37.754zm5.637 78.93h73.291V43.393H43.391v73.291zm90.206-78.93h84.567v84.567h-84.567V37.754zm5.637 78.93h73.291V43.393h-73.291v73.291zm-5.637 16.913h84.567v84.569h-84.567v-84.57zm5.637 78.928h73.291v-73.291h-73.291v73.291zm-101.48-78.928h84.567v84.569H37.754v-84.57zm5.637 78.928h73.291v-73.291H43.391v73.291z"
      fill="#fff"
    />
    <path
      d="M60.188 187.758l-59.8-59.8L60.187 68.16l59.8 59.798-59.798 59.8zm-51.826-59.8l51.826 51.826 51.824-51.826-51.826-51.824-51.824 51.824zm119.596-7.972L68.16 60.188l59.798-59.8 59.798 59.8-59.798 59.798zM76.134 60.188l51.824 51.824 51.826-51.824-51.826-51.826-51.824 51.826zm119.596 127.57l-59.798-59.8L195.73 68.16l59.798 59.798-59.798 59.8zm-51.826-59.8l51.826 51.826 51.824-51.826-51.824-51.824-51.826 51.824zm-15.946 127.57L68.16 195.73l59.798-59.798 59.798 59.798-59.798 59.798zM76.134 195.73l51.824 51.824 51.826-51.824-51.826-51.824-51.824 51.824z"
      fill="#FFF"
    />
  </svg>
);

export const Windows = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 256 257"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <path
      d="M0 36.357L104.62 22.11l.045 100.914-104.57.595L0 36.358zm104.57 98.293l.08 101.002L.081 221.275l-.006-87.302 104.494.677zm12.682-114.405L255.968 0v121.74l-138.716 1.1V20.246zM256 135.6l-.033 121.191-138.716-19.578-.194-101.84L256 135.6z"
      fill="#000"
    />
  </svg>
);

export const Coreos = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <path
      d="M128.008 0C57.418 0 0 57.42 0 128c0 70.584 57.417 128 128.008 128C198.578 256 256 198.584 256 128 256 57.42 198.578 0 128.008 0z"
      fill="#000"
    />
    <path
      d="M128.572 11.253c-20.384 0-37.671 32.604-43.915 77.92-.2 1.458-.393 2.933-.564 4.418a274.635 274.635 0 0 0-1.72 22.182 268.485 268.485 0 0 0-.205 10.6c0 3.573.068 7.111.206 10.597.289 7.633.867 15.054 1.72 22.186 9.557 1.237 19.777 2.076 30.436 2.475 4.608.172 9.284.275 14.043.275 4.744 0 9.435-.104 14.029-.275 10.672-.399 20.884-1.238 30.45-2.475 1.052-.135 2.088-.282 3.136-.434 39.809-5.59 67.502-17.965 67.502-32.349-.001-63.582-51.546-115.12-115.118-115.12z"
      fill="#fff"
    />
    <path
      d="M176.187 94.022a58.427 58.427 0 0 0-3.713-4.847c-10.562-12.451-26.297-20.363-43.901-20.363-5.707 0-10.79 8.736-14.043 22.301-1.293 5.41-2.296 11.58-2.943 18.279a180.47 180.47 0 0 0-.784 16.981c0 5.907.275 11.616.784 16.979 5.371.51 11.071.783 16.986.783 5.907 0 11.607-.274 16.978-.783 11.807-1.12 22-3.39 29.22-6.382 7.13-2.95 11.35-6.622 11.35-10.597-.001-11.992-3.663-23.13-9.934-32.351z"
      fill="#000"
    />
  </svg>
);

export const Suse = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 192.756 192.756"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="evenodd" clipRule="evenodd">
      <path fill="#fff" d="M0 0h192.756v192.756H0V0z" />
      <path
        d="M15.857 144.742c.289 10.1 7.792 14.574 17.171 14.574 8.081 0 16.161-3.607 16.161-12.844 0-4.184-2.597-8.801-7.936-10.389-2.165-.578-11.111-2.887-11.833-3.176-2.886-.721-4.762-2.309-4.762-5.193 0-4.186 4.185-5.34 7.503-5.34 4.906 0 8.369 2.021 8.802 7.215h7.07c0-8.514-7.07-12.986-15.584-12.986-7.359 0-15.007 3.752-15.007 11.977 0 4.186 2.02 8.514 9.091 10.389 5.627 1.443 9.235 2.311 12.121 3.32 1.731.576 3.463 1.875 3.463 5.051 0 3.029-2.453 6.203-8.658 6.203-5.771 0-10.389-2.453-10.389-8.801h-7.213zM88.727 128.725h-6.493v17.172c0 4.617-1.875 8.08-7.215 8.08-3.607 0-5.771-1.875-5.771-7.07v-18.182h-6.494v18.902c0 7.648 3.319 11.545 11.111 11.545 3.175 0 6.782-1.877 8.369-4.906h.145v4.039h6.349v-29.58h-.001zM102.291 144.742c.145 10.1 7.793 14.574 17.027 14.574 8.225 0 16.307-3.607 16.307-12.844 0-4.184-2.598-8.801-7.938-10.389-2.164-.578-11.254-2.887-11.832-3.176-2.887-.721-4.906-2.309-4.906-5.193 0-4.186 4.186-5.34 7.504-5.34 4.906 0 8.514 2.021 8.801 7.215h7.217c0-8.514-7.217-12.986-15.73-12.986-7.357 0-14.861 3.752-14.861 11.977 0 4.186 2.02 8.514 8.945 10.389 5.629 1.443 9.381 2.311 12.266 3.32 1.588.576 3.32 1.875 3.32 5.051 0 3.029-2.311 6.203-8.658 6.203-5.629 0-10.246-2.453-10.246-8.801h-7.216zM150.055 158.305h29.869v-6.061H157.27v-11.976h20.49v-5.916h-20.49v-10.678h22.22v-6.205h-29.435v40.836z"
        fill="#000"
      />
      <path
        d="M9.797 100.299c.144.287.144.432.144.576 3.175 8.514 9.235 11.977 19.192 11.4 6.782-.723 9.668-4.762 8.225-11.832l-8.658-.145c-.144 2.309-1.299 4.328-4.04 4.617h-.289c-3.319-.434-5.483-2.164-6.638-4.473l-7.936-.143zm11.399 0c.866 1.01 1.876 1.586 3.319 1.73.866-.145 1.299-.865 1.299-1.586l-4.618-.144zm35.209 0c0 1.441 0 3.752 3.175 3.895 4.185 0 4.185-2.02 4.473-3.75l-7.648-.145zm17.027 0c0 2.885.577 3.752 3.03 4.184 3.174.289 3.896-1.73 4.04-2.598.145-.576.145-1.01.289-1.586h-7.359zm46.607 0c.434 1.73.434 4.473 4.475 4.184 2.453-.289 2.598-2.453 2.309-4.184h-6.784zm16.307 0c1.299 3.174 3.029 4.039 5.338 3.463 1.443-.578 2.021-1.154 1.732-3.463h-7.07z"
        fill="#000"
      />
      <path
        d="M8.787 87.888c-.577 4.329-.288 8.514 1.01 12.411h7.937c-1.154-2.309-1.298-5.196-.577-7.937l.144-.289c.866-1.587 1.876-3.175 3.175-4.185H8.787zm46.608 0l.866 12.122c0 .145 0 .289.144.289h7.647v-.145c.145-8.37.145-9.524.433-12.266h-9.09zm18.181 0c.145.578 0 1.299-.144 2.021v7.214c0 1.299-.145 2.309 0 3.32l7.359-.145c.722-4.474.433-6.206 1.154-10.102.145-.866.145-1.587.289-2.309h-8.658v.001zm42.858 0l3.318 11.977c.145.145.145.289.287.434h6.783c0-.578-.145-1.012-.145-1.443-.578-2.886-1.01-7.071-1.443-10.534-.145-.145-.145-.289-.145-.434h-8.655zm16.015 0l2.887 9.668s.289 1.01 1.01 2.598v.145h7.07c0-.723-.289-1.877-.721-3.176 0 0-2.309-5.916-1.012-9.235h-9.234zM25.814 100.299c.145-.723 0-1.588-.289-2.166-1.731.289-2.597-2.308-.866-2.885 2.741-.866 4.329 2.165 4.04 5.196l8.658-.145c-.144-.578-.433-1.299-.577-2.021-2.598-5.194-5.483-8.225-8.658-9.09l-1.731.433c-2.742.577-5.05.866-6.493 3.607-.722 3.03-.289 5.483 1.298 7.071h4.618z"
        fill="#000"
      />
      <path
        d="M15.136 71.15c-3.463 5.483-5.628 11.255-6.35 16.738h11.688c.433-.433 1.01-.721 1.587-.866 1.299-.577 2.598-.866 4.041-1.154 1.298-2.886 4.618-5.628 9.812-7.792 9.668-2.453 17.893-.577 19.48 8.514v1.298h9.09c.144-.433.144-.721.144-1.154.866-4.329 8.803-5.627 8.947 1.154h8.658c.578-3.318 2.453-4.617 10.822-3.318 5.627 1.587 9.235.866 16.883.144 5.482-1.154 5.195.144 6.35 2.886l.145.289h8.656c-.721-3.896 2.598-10.966 7.215-.577l.145.577h9.234c.434-1.442 1.588-2.453 3.896-2.309 1.299-.289 2.887-.433 3.176-1.443-3.896-1.731-6.061-3.463-13.709-9.524-1.443-1.154.289-3.463 1.732-2.309 9.668 7.504 12.119 9.957 20.777 12.121 10.102.722 19.77-4.04 25.252-13.275h-4.906c-3.607 1.01-7.502 1.876-12.264 2.02-2.598-.144-4.906-.577-7.072-1.154a39.21 39.21 0 0 0-2.309-.866H15.136z"
        fill="#000"
      />
      <path
        d="M156.258 71.15c-2.596-1.01-5.627-2.453-8.514-2.886-2.309-.289-1.586-3.03-.143-3.03 5.627.866 12.408 5.195 18.037 5.339 7.936-.144 13.707-2.597 18.613-4.617-2.742-9.524-14.574-19.913-24.531-17.027-15.295-9.235-18.469-9.668-36.939-13.708-18.037-3.896-43.578-.722-57.863 3.03-13.131 4.473-23.232 7.07-40.547 21.933-3.752 3.463-6.782 7.215-9.235 10.967h141.122v-.001zm26.551 0c.289-.577.723-1.299 1.01-2.02-1.875.721-3.75 1.443-5.916 2.02h4.906zm-18.038-20.057c4.617 0 9.236 3.463 9.236 8.081 0 4.617-4.619 7.792-9.236 7.792s-7.646-3.896-7.646-8.514c0-4.473 3.029-7.359 7.646-7.359zm.723 2.02c-3.463 0-6.205 2.742-6.205 6.061 0 3.175 2.742 5.916 6.205 5.916s6.205-2.741 6.205-5.916c0-3.32-2.742-6.061-6.205-6.061zm.432 2.02c2.309 0 3.32 1.587 3.32 3.896 0 2.165-1.154 3.752-3.465 3.752-2.164 0-4.473-1.299-4.473-3.607.001-2.165 2.454-4.041 4.618-4.041zm-.576 2.309c-1.01 0-1.732.866-1.732 1.731 0 1.01.723 1.876 1.732 1.876s1.875-.866 1.875-1.876c0-.865-.866-1.731-1.875-1.731z"
        fill="#000"
      />
      <path
        d="M41.975 106.504h137.371v4.473H40.388s1.587-1.588 1.587-4.473z"
        fill="#000"
      />
    </g>
  </svg>
);

export const Fedora = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <path
      d="M256 128.004C256 57.31 198.691 0 127.998 0 57.336 0 .05 57.262 0 127.914v99.054c.038 16.042 13.049 29.029 29.101 29.029h98.949C198.72 255.969 256 198.679 256 128.004"
      fill="#000"
    />
    <path
      d="M165.58 30.307c-33.109 0-60.045 26.935-60.045 60.045v31.87H73.797c-33.109 0-60.045 26.937-60.045 60.046 0 33.108 26.936 60.045 60.045 60.045s60.045-26.937 60.045-60.045v-31.871h31.738c33.109 0 60.046-26.936 60.046-60.045 0-33.11-26.937-60.045-60.046-60.045zm-59.823 151.961c0 17.622-14.337 31.959-31.96 31.959s-31.96-14.337-31.96-31.959c0-17.623 14.337-31.96 31.96-31.96h31.738v.089h.222v31.871zm59.823-59.956h-31.738v-.09h-.221v-31.87c0-17.623 14.337-31.96 31.959-31.96s31.96 14.337 31.96 31.96-14.338 31.96-31.96 31.96z"
      fill="#000"
    />
    <path
      d="M178.851 32.128c-4.66-1.218-8.238-1.786-13.271-1.786-33.177 0-60.075 26.899-60.075 60.074v31.842h-25.16c-7.845 0-14.185 6.165-14.18 13.996 0 7.782 6.27 13.973 14.032 13.973l20.831.004c2.473 0 4.479 2 4.479 4.469v27.553c-.031 17.491-14.219 31.659-31.71 31.659-5.925 0-7.392-.776-11.437-.776-8.497 0-14.182 5.696-14.182 13.528.002 6.479 5.554 12.049 12.348 13.827 4.66 1.218 8.238 1.787 13.271 1.787 33.177 0 60.075-26.899 60.075-60.075v-31.841h25.16c7.845 0 14.185-6.165 14.18-13.996 0-7.783-6.27-13.973-14.032-13.973l-20.831-.004a4.475 4.475 0 0 1-4.479-4.47V90.366c.031-17.491 14.219-31.659 31.71-31.659 5.925 0 7.392.777 11.437.777 8.497 0 14.182-5.697 14.182-13.528-.002-6.48-5.554-12.05-12.348-13.828"
      fill="#FFF"
    />
  </svg>
);

export const FreeBSD = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 256 252"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <g fill="#000">
      <path d="M252.723 5.11c13.508 13.5-23.939 72.848-30.27 79.182-6.33 6.321-22.409.505-35.91-13-13.508-13.5-19.327-29.583-12.996-35.914 6.327-6.333 65.671-43.777 79.176-30.269M63.305 19.394c-20.622-11.7-49.966-24.716-59.3-15.38-9.458 9.454 4.034 39.458 15.858 60.117a126.812 126.812 0 0 1 43.442-44.737" />
      <path d="M232.123 79.636c1.899 6.44 1.558 11.76-1.522 14.834-7.193 7.196-26.624-.464-44.14-17.134a89.383 89.383 0 0 1-3.627-3.428c-6.334-6.336-11.262-13.08-14.414-19.291-6.135-11.006-7.67-20.726-3.033-25.364 2.527-2.524 6.57-3.212 11.502-2.325 3.216-2.034 7.013-4.3 11.176-6.621-16.929-8.83-36.176-13.817-56.593-13.817C63.753 6.49 8.854 61.38 8.854 129.105c0 67.713 54.9 122.61 122.618 122.61 67.72 0 122.616-54.897 122.616-122.61 0-21.87-5.74-42.377-15.767-60.156-2.167 3.955-4.274 7.578-6.198 10.687" />
    </g>
  </svg>
);

export const Ubuntu = () => (
  <svg
    width="26"
    height="26"
    viewBox="11.811 12.73 275.689 274.539"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="40.158" cy="150.022" rx="28.347" ry="26.52" fill="#000" />
    <ellipse cx="238.479" cy="260.747" rx="28.347" ry="26.521" fill="#000" />
    <path
      d="M172.369 83.824c34.439 0 63.014 24.735 67.745 56.803H287.5c-2.152-25.198-12.953-48.684-31.01-67.207-11.565 5.697-25.785 5.806-37.865-.938-12.089-6.752-19.104-18.727-19.776-31.276a120.229 120.229 0 0 0-26.479-2.938c-17.29 0-33.998 3.651-49.195 10.573l23.723 39.745a70.087 70.087 0 0 1 25.471-4.762z"
      fill="#000"
    />
    <path
      d="M240.117 159.387c-4.72 32.08-33.299 56.83-67.748 56.83-9.002 0-17.602-1.694-25.48-4.768l-23.727 39.748c15.193 6.926 31.908 10.579 49.205 10.579 9.035 0 17.914-1.009 26.5-2.944.66-12.563 7.678-24.559 19.775-31.314 12.084-6.75 26.31-6.641 37.877-.932 18.043-18.525 28.832-42.01 30.978-67.199h-47.38z"
      fill="#000"
    />
    <path
      d="M103.934 150.021c0-21.09 10.249-39.906 26.179-52.036l-23.717-39.739a116.407 116.407 0 0 0-15.727 12.752C76.943 84.274 67.1 100.305 61.683 117.8c10.913 6.838 18.139 18.707 18.139 32.221 0 13.512-7.227 25.384-18.14 32.219 5.417 17.496 15.26 33.525 28.986 46.803a116.433 116.433 0 0 0 15.714 12.748l23.721-39.742c-15.926-12.129-26.169-30.945-26.169-52.028z"
      fill="#000"
    />
    <ellipse cx="238.456" cy="39.252" rx="28.346" ry="26.522" fill="#000" />
  </svg>
);

export const Debian = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 256 317"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <g fill="#000">
      <path d="M152.797 167.425c-5.251.073.993 2.706 7.848 3.761a70.171 70.171 0 0 0 5.143-4.43c-4.269 1.046-8.614 1.07-12.991.67M180.98 160.4c3.127-4.315 5.406-9.04 6.21-13.926-.702 3.483-2.593 6.49-4.372 9.663-9.815 6.18-.923-3.67-.006-7.413-10.554 13.284-1.45 7.966-1.832 11.677M191.382 133.33c.635-9.455-1.86-6.466-2.7-2.857.98.508 1.754 6.665 2.7 2.858M132.886 4.088c2.802.503 6.054.888 5.598 1.557 3.066-.672 3.761-1.291-5.598-1.557M138.484 5.645l-1.98.41 1.843-.164.137-.246" />
      <path d="M225.866 136.916c.312 8.492-2.484 12.612-5.006 19.905l-4.538 2.268c-3.714 7.211.36 4.579-2.3 10.315-5.797 5.154-17.593 16.13-21.368 17.132-2.756-.062 1.867-3.253 2.472-4.503-7.761 5.33-6.227 8-18.097 11.238l-.347-.771c-29.274 13.771-69.937-13.52-69.402-50.76-.313 2.364-.889 1.774-1.537 2.73-1.511-19.16 8.848-38.405 26.319-46.262 17.088-8.46 37.122-4.988 49.362 6.42-6.724-8.808-20.107-18.144-35.968-17.27-15.536.245-30.07 10.12-34.921 20.837-7.96 5.012-8.883 19.318-12.352 21.936-4.666 34.296 8.778 49.114 31.52 66.544 3.58 2.414 1.009 2.78 1.494 4.617-7.557-3.539-14.476-8.88-20.165-15.42 3.018 4.419 6.276 8.714 10.487 12.089-7.124-2.414-16.641-17.264-19.42-17.868 12.281 21.988 49.827 38.562 69.486 30.34-9.096.335-20.653.186-30.874-3.592-4.293-2.209-10.13-6.785-9.088-7.641 26.83 10.023 54.546 7.591 77.762-11.02 5.906-4.599 12.358-12.424 14.222-12.532-2.808 4.222.48 2.03-1.677 5.76 5.885-9.491-2.557-3.864 6.083-16.39l3.191 4.394c-1.186-7.878 9.783-17.444 8.67-29.904 2.516-3.81 2.808 4.1.137 12.866 3.706-9.725.976-11.288 1.929-19.312 1.029 2.697 2.379 5.564 3.071 8.41-2.414-9.398 2.478-15.826 3.688-21.288-1.193-.528-3.726 4.156-4.305-6.945.085-4.822 1.342-2.528 1.827-3.714-.947-.544-3.43-4.24-4.941-11.33 1.095-1.665 2.927 4.32 4.418 4.565-.959-5.637-2.61-9.935-2.677-14.26-4.354-9.099-1.54 1.213-5.073-3.906-4.634-14.456 3.846-3.355 4.419-9.924 7.024 10.178 11.03 25.951 12.868 32.485-1.402-7.966-3.67-15.683-6.437-23.149 2.133.897-3.436-16.39 2.773-4.94-6.633-24.406-28.388-47.21-48.401-57.91 2.449 2.24 5.54 5.055 4.43 5.496-9.953-5.926-8.202-6.388-9.628-8.892-8.109-3.299-8.64.266-14.012.006-15.282-8.106-18.227-7.244-32.291-12.322l.64 2.99c-10.125-3.373-11.797 1.279-22.74.01-.666-.52 3.507-1.881 6.94-2.38-9.789 1.29-9.33-1.93-18.909.356 2.361-1.657 4.857-2.753 7.376-4.161-7.983.485-19.058 4.646-15.64.862-13.02 5.809-36.145 13.964-49.122 26.132l-.41-2.727c-5.945 7.14-25.93 21.32-27.522 30.565l-1.59.371c-3.094 5.24-5.096 11.177-7.55 16.568-4.047 6.896-5.932 2.654-5.356 3.735-7.96 16.138-11.914 29.7-15.33 40.821 2.435 3.638.059 21.9.98 36.517-3.998 72.187 50.662 142.275 110.41 158.458 8.757 3.132 21.78 3.012 32.858 3.334-13.07-3.738-14.76-1.981-27.49-6.42-9.185-4.325-11.198-9.263-17.702-14.908l2.574 4.55c-12.758-4.515-7.42-5.588-17.798-8.875l2.75-3.591c-4.135-.313-10.953-6.97-12.817-10.654l-4.523.178c-5.435-6.706-8.331-11.54-8.12-15.282l-1.462 2.603c-1.657-2.843-19.995-25.15-10.481-19.957-1.768-1.616-4.117-2.63-6.665-7.259l1.937-2.215c-4.579-5.89-8.427-13.441-8.135-15.957 2.443 3.299 4.138 3.915 5.815 4.48-11.563-28.69-12.211-1.581-20.969-29.204l1.853-.149c-1.42-2.139-2.282-4.462-3.425-6.74l.807-8.037c-8.325-9.625-2.33-40.926-1.128-58.093.832-6.98 6.948-14.412 11.6-26.065l-2.834-.488c5.417-9.45 30.933-37.952 42.75-36.485 5.724-7.19-1.137-.026-2.256-1.838 12.573-13.012 16.527-9.193 25.013-11.533 9.151-5.432-7.855 2.118-3.516-2.072 15.82-4.041 11.212-9.187 31.85-11.238 2.178 1.239-5.051 1.914-6.866 3.521 13.181-6.449 41.712-4.982 60.244 3.58 21.504 10.049 45.663 39.754 46.616 67.704l1.084.292c-.55 11.11 1.7 23.958-2.198 35.76l2.654-5.587" />
      <path d="M95.483 174.634l-.736 3.682c3.45 4.687 6.189 9.765 10.595 13.43-3.17-6.19-5.525-8.746-9.859-17.112M103.642 174.313c-1.827-2.02-2.908-4.45-4.117-6.873 1.157 4.257 3.526 7.916 5.733 11.636l-1.616-4.763M248.003 142.936l-.771 1.934c-1.414 10.046-4.468 19.987-9.15 29.203 5.173-9.725 8.519-20.36 9.921-31.137M133.923 1.57c3.55-1.301 8.728-.714 12.495-1.57-4.91.412-9.795.657-14.62 1.28l2.125.29M9.282 67.847c.819 7.574-5.698 10.514 1.444 5.52 3.828-8.623-1.496-2.381-1.444-5.52M.89 102.9c1.645-5.049 1.943-8.082 2.572-11.004C-1.085 97.708 1.37 98.946.89 102.9" />
    </g>
  </svg>
);

export const Magnum = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 3730 4460"
    preserveAspectRatio="xMidYMid meet"
  >
    <path d="M2275 4308 c-3 -7 -6 -128 -7 -268 l-3 -255 -32 -67 c-42 -90 -121 -169 -210 -211 l-68 -32 -265 -5 -265 -5 -3 -26 c-3 -24 47 -119 83 -159 8 -9 15 -19 15 -23 0 -11 114 -117 133 -123 9 -3 17 -9 17 -13 0 -14 131 -72 210 -94 79 -21 148 -24 390 -19 149 4 243 -11 292 -48 15 -11 32 -20 37 -20 10 0 114 -99 144 -138 10 -13 31 -57 47 -98 23 -57 30 -91 30 -142 0 -64 -21 -155 -41 -176 -5 -6 -9 -16 -9 -23 0 -22 -74 -116 -121 -153 -94 -75 -222 -120 -236 -82 -6 14 38 216 58 270 23 58 1 158 -42 202 -81 80 -191 78 -299 -8 -61 -48 -187 -178 -218 -224 -13 -21 -29 -38 -33 -38 -5 0 -9 -6 -9 -13 0 -7 -7 -22 -15 -32 -28 -36 -85 -137 -85 -151 0 -22 -35 -34 -95 -34 -77 0 -254 -27 -340 -52 -38 -11 -87 -24 -109 -29 -21 -5 -57 -18 -79 -29 -22 -11 -45 -20 -51 -20 -15 0 -174 -79 -181 -90 -3 -6 -13 -10 -21 -10 -9 0 -21 -6 -29 -12 -7 -7 -32 -25 -56 -40 -73 -46 -83 -53 -94 -64 -5 -5 -32 -28 -60 -49 -64 -51 -179 -165 -230 -230 -22 -27 -43 -51 -47 -53 -5 -2 -8 -9 -8 -16 0 -7 -11 -23 -25 -36 -14 -13 -25 -28 -25 -33 0 -5 -10 -23 -22 -40 -24 -34 -42 -66 -96 -172 -40 -80 -53 -179 -33 -252 16 -60 92 -134 154 -151 36 -9 215 -12 729 -12 592 0 690 -2 747 -16 60 -15 140 -56 183 -94 9 -8 25 -22 35 -30 9 -8 67 -62 128 -120 141 -134 182 -170 194 -170 4 0 14 -7 21 -15 21 -25 119 -75 199 -101 63 -20 94 -24 162 -22 l84 3 6 130 c6 138 33 279 77 400 38 107 123 276 158 316 8 8 14 20 14 26 0 6 3 13 8 15 4 2 27 28 51 58 25 30 57 69 73 85 28 30 72 82 86 100 50 68 82 117 82 124 0 5 6 16 13 23 22 22 137 271 137 297 0 6 12 50 27 98 26 85 26 96 27 338 0 245 -1 252 -27 330 -15 44 -27 86 -27 92 0 26 -90 215 -139 293 -41 64 -31 52 -124 165 -41 50 -100 110 -131 135 -31 25 -56 48 -56 52 0 5 -6 8 -13 8 -8 0 -24 11 -37 25 -13 14 -29 25 -35 25 -23 0 -135 112 -169 169 -39 64 -66 169 -66 258 0 73 -25 186 -56 248 -13 28 -24 54 -24 58 0 13 -75 112 -119 156 -45 45 -133 111 -149 111 -5 0 -19 9 -32 20 -26 22 -78 27 -85 8z m-810 -2732 c39 -67 60 -182 46 -259 -11 -62 -57 -168 -76 -173 -5 -2 -29 13 -53 34 l-43 37 17 45 c25 66 24 192 -3 250 l-20 45 46 32 c25 18 49 32 53 32 4 1 19 -19 33 -43z m314 -6 c29 -52 51 -138 51 -203 0 -74 -60 -228 -88 -227 -4 1 -26 18 -49 38 l-42 37 19 55 c25 72 25 156 0 222 -11 29 -20 56 -20 60 0 11 84 67 95 64 6 -1 21 -22 34 -46z m-814 -515 c16 -15 25 -36 25 -55 0 -19 -9 -40 -25 -55 -15 -16 -36 -25 -55 -25 -19 0 -40 9 -55 25 -16 15 -25 36 -25 55 0 19 9 40 25 55 15 16 36 25 55 25 19 0 40 -9 55 -25z" />
  </svg>
);

export const Rocky = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 192 192"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M186.658 127.658C190.119 117.746 192 107.093 192 96C192 42.9807 149.019 0 96 0C42.9807 0 0 42.9807 0 96C0 122.234 10.523 146.011 27.5783 163.338L124.958 65.9584L149 90L186.658 127.658ZM169.122 158.205L124.958 114.042L55.7978 183.202C68.0269 188.849 81.6455 192 96 192C125.288 192 151.514 178.884 169.122 158.205Z" />
  </svg>
);

export const Linux = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 304.998 304.998"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M274.659,244.888c-8.944-3.663-12.77-8.524-12.4-15.777c0.381-8.466-4.422-14.667-6.703-17.117
		c1.378-5.264,5.405-23.474,0.004-39.291c-5.804-16.93-23.524-42.787-41.808-68.204c-7.485-10.438-7.839-21.784-8.248-34.922
		c-0.392-12.531-0.834-26.735-7.822-42.525C190.084,9.859,174.838,0,155.851,0c-11.295,0-22.889,3.53-31.811,9.684
		c-18.27,12.609-15.855,40.1-14.257,58.291c0.219,2.491,0.425,4.844,0.545,6.853c1.064,17.816,0.096,27.206-1.17,30.06
		c-0.819,1.865-4.851,7.173-9.118,12.793c-4.413,5.812-9.416,12.4-13.517,18.539c-4.893,7.387-8.843,18.678-12.663,29.597
		c-2.795,7.99-5.435,15.537-8.005,20.047c-4.871,8.676-3.659,16.766-2.647,20.505c-1.844,1.281-4.508,3.803-6.757,8.557
		c-2.718,5.8-8.233,8.917-19.701,11.122c-5.27,1.078-8.904,3.294-10.804,6.586c-2.765,4.791-1.259,10.811,0.115,14.925
		c2.03,6.048,0.765,9.876-1.535,16.826c-0.53,1.604-1.131,3.42-1.74,5.423c-0.959,3.161-0.613,6.035,1.026,8.542
		c4.331,6.621,16.969,8.956,29.979,10.492c7.768,0.922,16.27,4.029,24.493,7.035c8.057,2.944,16.388,5.989,23.961,6.913
		c1.151,0.145,2.291,0.218,3.39,0.218c11.434,0,16.6-7.587,18.238-10.704c4.107-0.838,18.272-3.522,32.871-3.882
		c14.576-0.416,28.679,2.462,32.674,3.357c1.256,2.404,4.567,7.895,9.845,10.724c2.901,1.586,6.938,2.495,11.073,2.495
		c0.001,0,0,0,0.001,0c4.416,0,12.817-1.044,19.466-8.039c6.632-7.028,23.202-16,35.302-22.551c2.7-1.462,5.226-2.83,7.441-4.065
		c6.797-3.768,10.506-9.152,10.175-14.771C282.445,250.905,279.356,246.811,274.659,244.888z M124.189,243.535
		c-0.846-5.96-8.513-11.871-17.392-18.715c-7.26-5.597-15.489-11.94-17.756-17.312c-4.685-11.082-0.992-30.568,5.447-40.602
		c3.182-5.024,5.781-12.643,8.295-20.011c2.714-7.956,5.521-16.182,8.66-19.783c4.971-5.622,9.565-16.561,10.379-25.182
		c4.655,4.444,11.876,10.083,18.547,10.083c1.027,0,2.024-0.134,2.977-0.403c4.564-1.318,11.277-5.197,17.769-8.947
		c5.597-3.234,12.499-7.222,15.096-7.585c4.453,6.394,30.328,63.655,32.972,82.044c2.092,14.55-0.118,26.578-1.229,31.289
		c-0.894-0.122-1.96-0.221-3.08-0.221c-7.207,0-9.115,3.934-9.612,6.283c-1.278,6.103-1.413,25.618-1.427,30.003
		c-2.606,3.311-15.785,18.903-34.706,21.706c-7.707,1.12-14.904,1.688-21.39,1.688c-5.544,0-9.082-0.428-10.551-0.651l-9.508-10.879
		C121.429,254.489,125.177,250.583,124.189,243.535z M136.254,64.149c-0.297,0.128-0.589,0.265-0.876,0.411
		c-0.029-0.644-0.096-1.297-0.199-1.952c-1.038-5.975-5-10.312-9.419-10.312c-0.327,0-0.656,0.025-1.017,0.08
		c-2.629,0.438-4.691,2.413-5.821,5.213c0.991-6.144,4.472-10.693,8.602-10.693c4.85,0,8.947,6.536,8.947,14.272
		C136.471,62.143,136.4,63.113,136.254,64.149z M173.94,68.756c0.444-1.414,0.684-2.944,0.684-4.532
		c0-7.014-4.45-12.509-10.131-12.509c-5.552,0-10.069,5.611-10.069,12.509c0,0.47,0.023,0.941,0.067,1.411
		c-0.294-0.113-0.581-0.223-0.861-0.329c-0.639-1.935-0.962-3.954-0.962-6.015c0-8.387,5.36-15.211,11.95-15.211
		c6.589,0,11.95,6.824,11.95,15.211C176.568,62.78,175.605,66.11,173.94,68.756z M169.081,85.08
		c-0.095,0.424-0.297,0.612-2.531,1.774c-1.128,0.587-2.532,1.318-4.289,2.388l-1.174,0.711c-4.718,2.86-15.765,9.559-18.764,9.952
		c-2.037,0.274-3.297-0.516-6.13-2.441c-0.639-0.435-1.319-0.897-2.044-1.362c-5.107-3.351-8.392-7.042-8.763-8.485
		c1.665-1.287,5.792-4.508,7.905-6.415c4.289-3.988,8.605-6.668,10.741-6.668c0.113,0,0.215,0.008,0.321,0.028
		c2.51,0.443,8.701,2.914,13.223,4.718c2.09,0.834,3.895,1.554,5.165,2.01C166.742,82.664,168.828,84.422,169.081,85.08z
		 M205.028,271.45c2.257-10.181,4.857-24.031,4.436-32.196c-0.097-1.855-0.261-3.874-0.42-5.826
		c-0.297-3.65-0.738-9.075-0.283-10.684c0.09-0.042,0.19-0.078,0.301-0.109c0.019,4.668,1.033,13.979,8.479,17.226
		c2.219,0.968,4.755,1.458,7.537,1.458c7.459,0,15.735-3.659,19.125-7.049c1.996-1.996,3.675-4.438,4.851-6.372
		c0.257,0.753,0.415,1.737,0.332,3.005c-0.443,6.885,2.903,16.019,9.271,19.385l0.927,0.487c2.268,1.19,8.292,4.353,8.389,5.853
		c-0.001,0.001-0.051,0.177-0.387,0.489c-1.509,1.379-6.82,4.091-11.956,6.714c-9.111,4.652-19.438,9.925-24.076,14.803
		c-6.53,6.872-13.916,11.488-18.376,11.488c-0.537,0-1.026-0.068-1.461-0.206C206.873,288.406,202.886,281.417,205.028,271.45z
		 M39.917,245.477c-0.494-2.312-0.884-4.137-0.465-5.905c0.304-1.31,6.771-2.714,9.533-3.313c3.883-0.843,7.899-1.714,10.525-3.308
		c3.551-2.151,5.474-6.118,7.17-9.618c1.228-2.531,2.496-5.148,4.005-6.007c0.085-0.05,0.215-0.108,0.463-0.108
		c2.827,0,8.759,5.943,12.177,11.262c0.867,1.341,2.473,4.028,4.331,7.139c5.557,9.298,13.166,22.033,17.14,26.301
		c3.581,3.837,9.378,11.214,7.952,17.541c-1.044,4.909-6.602,8.901-7.913,9.784c-0.476,0.108-1.065,0.163-1.758,0.163
		c-7.606,0-22.662-6.328-30.751-9.728l-1.197-0.503c-4.517-1.894-11.891-3.087-19.022-4.241c-5.674-0.919-13.444-2.176-14.732-3.312
		c-1.044-1.171,0.167-4.978,1.235-8.337c0.769-2.414,1.563-4.91,1.998-7.523C41.225,251.596,40.499,248.203,39.917,245.477z"
    />
  </svg>
);

export const Gardener = ({ className, width, height }) => (
  <svg
    viewBox="0 0 28 28"
    className={className || " "}
    xmlns="http://www.w3.org/2000/svg"
    width={width || "28"}
    height={height || "26"}
    strokeLinecap="round"
    strokeLinejoin="round"
    fillRule="evenodd"
  >
    <path
      d="M12.8611.0601c.1659-.0801.359-.0801.5249 0l10.0392 4.8535a.607.607 0 0 1 .3273.412l2.4795 10.9057c.0409.1802-.0021.3693-.1169.5138l-6.9473 8.7457a.604.604 0 0 1-.4729.2287H7.5522a.604.604 0 0 1-.4729-.2287L.132 16.7451a.609.609 0 0 1-.1168-.5138L2.4946 5.3256c.041-.1801.1615-.3318.3273-.412L12.8611.0601zm-3.8782 11.452V7.7977c0-.1176.0226-.2321.0648-.3381l3.4543 2.2417 4.2346-2.5438a.911.911 0 0 1 .0647.3375v4.22c0 .1118-.0205.2208-.0588.3224l3.0968-1.7722a.912.912 0 0 1 .0628.3328v6.2353c0 .3253-.1729.6261-.4536.7888l-5.3789 3.1175c-.1085.0629-.2267.1015-.3471.1157l-.1169.0678a.904.904 0 0 1-.9074 0l-5.3788-3.1175c-.2807-.1627-.4536-.4635-.4536-.7888v-6.2352c0-.1407.0323-.2766.0916-.3989z"
      stroke="none"
    />
  </svg>
);

export const CleuraLogoOnly = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="null"
      transform="matrix(0.437641 0 0 -0.437641 8.06123 37.1534)"
      id="svg_2"
    >
      <g
        stroke="null"
        transform="translate(-5 -140) scale(0.08 0.08)"
        id="svg_3"
      >
        <path
          stroke="null"
          id="svg_5"
          d="m475.03139,2658.36518l-187.676,54.801l-0.664,-195.512l187.676,-54.8l0.664,195.511"
        />
        <path
          stroke="null"
          id="svg_4"
          d="m316.94939,2373.88518c-10.234,-29.785 -29.203,-56.918 -56.34,-77.192c-71.84,-53.675 -173.594,-38.945 -227.266,32.899c-53.671,71.84 -38.945,173.59 32.899,227.265c27.133,20.274 58.531,30.77 89.996,32.137l0.551,162.399c-65.504,-1.282 -131.242,-22.25 -187.735,-64.453c-143.6833,-107.348 -173.1403,-310.852 -65.7926,-454.536c107.3476,-143.6833 310.8516,-173.1403 454.5356,-65.7926c56.492,42.2066 95.238,99.3006 115.043,161.7536l-155.891,45.52"
        />
      </g>
    </g>{" "}
  </svg>
);

export const Fingerprint = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="20"
    height="20"
  >
    <path d="m257.778 193.333c-17.795 0-32.222 14.428-32.222 32.222v96.667c0 17.795 14.428 32.222 32.222 32.222s32.222-14.427 32.222-32.222v-96.667c0-17.794-14.428-32.222-32.222-32.222z" />
    <path
      id="path-1"
      d="m257.778 386.667c-17.795 0-32.222 14.428-32.222 32.222v64.444c0 17.81 14.428 32.222 32.222 32.222s32.222-14.411 32.222-32.221v-64.444c0-17.796-14.428-32.223-32.222-32.223z"
      transform="translate(7 12)"
    />
    <path d="m257.778 96.667c-71.068 0-128.889 57.821-128.889 128.889v64.444c0 17.795 14.428 32.222 32.222 32.222s32.222-14.428 32.222-32.222v-64.444c0-35.542 28.902-64.444 64.444-64.444s64.444 28.902 64.444 64.444v225.556c0 17.81 14.428 32.222 32.222 32.222 17.795 0 32.222-14.412 32.222-32.222v-225.556c.002-71.069-57.819-128.889-128.887-128.889z" />
    <path
      id="path-1_1_"
      d="m161.111 354.445c-17.795 0-32.222 14.428-32.222 32.222v64.444c0 17.81 14.428 32.222 32.222 32.222s32.222-14.412 32.222-32.222v-64.444c0-17.795-14.427-32.222-32.222-32.222z"
      transform="translate(4 11)"
    />
    <path d="m95.408 115.704c-16.19-7.363-35.306-.33-42.732 15.859-13.562 29.61-20.454 61.235-20.454 93.992v161.111c0 17.795 14.428 32.222 32.222 32.222s32.222-14.428 32.222-32.222v-161.111c0-23.427 4.909-46.005 14.601-67.119 7.411-16.174.315-35.306-15.859-42.732z" />
    <path d="m163.817 94.669c27.471-19.777 59.976-30.224 93.961-30.224 88.832 0 161.111 72.28 161.111 161.111 0 17.795 14.428 32.222 32.222 32.222s32.222-14.428 32.222-32.222c.001-124.374-101.182-225.556-225.555-225.556-47.578 0-93.08 14.648-131.595 42.355-14.443 10.384-17.732 30.523-7.348 44.966 10.384 14.428 30.508 17.732 44.982 7.348z" />
    <path d="m451.111 290c-17.795 0-32.222 14.428-32.222 32.222v64.444c0 17.795 14.428 32.222 32.222 32.222 17.795 0 32.222-14.428 32.222-32.222v-64.444c.001-17.794-14.427-32.222-32.222-32.222z" />
  </svg>
);

export const SMS = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="20"
    height="20"
  >
    <path
      d="M467,120H287c-24.814,0-45,20.186-45,45v122c0,24.814,20.186,45,45,45h15v45c0,6.064,3.647,11.543,9.258,13.857
			c1.86,0.776,3.809,1.143,5.742,1.143c3.896,0,7.734-1.523,10.605-4.395L383.211,332H467c24.814,0,45-20.186,45-45V165
			C512,140.186,491.814,120,467,120z M377,272h-60c-8.291,0-15-6.709-15-15c0-8.291,6.709-15,15-15h60c8.291,0,15,6.709,15,15
			S385.291,272,377,272z M437,210H317c-8.291,0-15-6.709-15-15s6.709-15,15-15h120c8.291,0,15,6.709,15,15S445.291,210,437,210z"
    />
    <path d="M287,0H45C20.186,0,0,20.186,0,45v15h332V45C332,20.186,311.814,0,287,0z" />
    <path
      d="M299.7,418.543C282.913,411.614,272,395.296,272,377v-16.509c-34.189-6.973-60-37.266-60-73.491V165
			c0-41.353,33.647-75,75-75H0v317c0,8.291,6.709,15,15,15h302C311.023,422,305.208,420.843,299.7,418.543z"
    />
    <path d="M0,452v15c0,24.814,20.186,45,45,45h242c24.814,0,45-20.186,45-45v-15H0z" />
  </svg>
);

export const FaceId = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20px"
    height="20px"
  >
    <path
      d="M 6 3 C 4.3550302 3 3 4.3550302 3 6 L 3 8 L 5 8 L 5 6 C 5 5.4349698 5.4349698 5 6 5 L 8 5 L 8 3 L 6 3 z M 16 3 L 16 5 L 18 5 C 18.56503 5 19 5.4349698 19 6 L 19 8 L 21 8 L 21 6 C 21 4.3550302 19.64497 3 18 3 L 16 3 z M 7 8 L 7 11 L 9 11 L 9 8 L 7 8 z M 11 8 L 11 12 L 10 12 L 10 14 L 11 14 C 12.093063 14 13 13.093063 13 12 L 13 8 L 11 8 z M 15 8 L 15 11 L 17 11 L 17 8 L 15 8 z M 9.7070312 15.292969 L 8.2929688 16.707031 C 8.2929688 16.707031 8.6834774 17.084903 9.3027344 17.394531 C 9.9219913 17.70416 10.833333 18 12 18 C 13.166667 18 14.078009 17.70416 14.697266 17.394531 C 15.316523 17.084903 15.707031 16.707031 15.707031 16.707031 L 14.292969 15.292969 C 14.292969 15.292969 14.183477 15.415097 13.802734 15.605469 C 13.421991 15.79584 12.833333 16 12 16 C 11.166667 16 10.578009 15.79584 10.197266 15.605469 C 9.8165222 15.415097 9.7070312 15.292969 9.7070312 15.292969 z M 3 16 L 3 18 C 3 19.64497 4.3550302 21 6 21 L 8 21 L 8 19 L 6 19 C 5.4349698 19 5 18.56503 5 18 L 5 16 L 3 16 z M 19 16 L 19 18 C 19 18.56503 18.56503 19 18 19 L 16 19 L 16 21 L 18 21 C 19.64497 21 21 19.64497 21 18 L 21 16 L 19 16 z"
      strokeLinecap="round"
    />
  </svg>
);

export const WindowsHello = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="20px"
    height="20px"
  >
    <path
      d="M256,0C114.618,0,0,114.618,0,256s114.618,256,256,256s256-114.618,256-256S397.382,0,256,0z M256,469.333
            c-117.818,0-213.333-95.515-213.333-213.333S138.182,42.667,256,42.667S469.333,138.182,469.333,256S373.818,469.333,256,469.333
            z"
    />
    <path
      d="M341.333,213.333c23.573,0,42.667-19.093,42.667-42.667C384,147.093,364.907,128,341.333,128
            c-23.573,0-42.667,19.093-42.667,42.667C298.667,194.24,317.76,213.333,341.333,213.333z"
    />
    <path
      d="M170.667,213.333c23.573,0,42.667-19.093,42.667-42.667c0-23.573-19.093-42.667-42.667-42.667
            C147.093,128,128,147.093,128,170.667C128,194.24,147.093,213.333,170.667,213.333z"
    />
    <path
      d="M384,256c-11.782,0-21.333,9.551-21.333,21.333C362.667,333.434,312.101,384,256,384s-106.667-50.566-106.667-106.667
				c0-11.782-9.551-21.333-21.333-21.333c-11.782,0-21.333,9.551-21.333,21.333c0,79.665,69.669,149.333,149.333,149.333
				s149.333-69.669,149.333-149.333C405.333,265.551,395.782,256,384,256z"
    />
  </svg>
);

export const USB = () => (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
  >
    <path
      d="M346,0H166c-8.291,0-15,6.709-15,15v105h210V15C361,6.709,354.291,0,346,0z M241,75c0,8.291-6.709,15-15,15
			s-15-6.709-15-15V45c0-8.291,6.709-15,15-15s15,6.709,15,15V75z M301,75c0,8.291-6.709,15-15,15c-8.291,0-15-6.709-15-15V45
			c0-8.291,6.709-15,15-15c8.291,0,15,6.709,15,15V75z"
    />
    <path
      d="M256,332c-24.814,0-45,20.186-45,45c0,24.814,20.186,45,45,45c24.814,0,45-20.186,45-45C301,352.186,280.814,332,256,332z
			"
    />
    <path
      d="M376,150H136c-8.291,0-15,6.709-15,15v212c0,74.443,60.557,135,135,135s135-60.557,135-135V165
			C391,156.709,384.291,150,376,150z M256,452c-41.353,0-75-33.647-75-75c0-41.353,33.647-75,75-75c41.353,0,75,33.647,75,75
			C331,418.353,297.353,452,256,452z"
    />
  </svg>
);

export const OrchestrationHeat = () => (
  <svg viewBox="0 0 480 480" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
      <path
        d="M2592 5027 c-29 -29 -52 -59 -52 -68 0 -8 12 -31 26 -50 88 -117 133
-282 113 -412 -14 -88 -49 -180 -95 -243 -18 -27 -350 -366 -738 -754 -449
-450 -717 -725 -739 -761 -89 -141 -117 -292 -81 -446 14 -62 55 -157 90 -208
26 -38 2028 -2035 2040 -2035 16 0 124 110 124 127 0 7 -20 35 -45 63 -58 66
-81 112 -95 194 -16 89 -1 177 45 254 24 41 144 168 412 438 209 208 391 396
407 417 35 48 71 129 92 209 35 135 1 322 -82 447 -21 31 -227 246 -461 480
-232 233 -423 431 -423 439 0 9 89 106 198 216 163 166 204 213 234 271 51
101 68 168 68 278 0 117 -30 218 -94 316 -51 79 -847 881 -874 881 -10 0 -41
-24 -70 -53z m443 -603 c68 -112 72 -263 10 -384 -10 -19 -99 -117 -199 -218
-131 -133 -186 -182 -201 -180 -34 5 -50 54 -50 158 0 85 3 102 31 160 17 36
43 79 59 95 109 118 195 318 195 456 0 31 3 59 7 63 10 10 117 -99 148 -150z
m306 -292 c15 -15 39 -52 55 -82 27 -51 29 -63 29 -165 0 -164 -11 -182 -250
-422 -105 -106 -196 -193 -202 -193 -12 0 -193 179 -193 191 0 5 92 102 205
216 221 224 254 270 290 403 25 94 26 95 66 52z m-953 -424 c7 -7 12 -21 12
-33 0 -26 42 -135 64 -167 9 -12 16 -29 16 -38 0 -17 -500 -520 -517 -520 -21
0 -36 32 -49 97 -16 87 -3 180 37 251 31 56 389 422 412 422 7 0 18 -5 25 -12z
m344 -498 l89 -90 -20 -28 c-36 -49 -499 -502 -513 -502 -8 0 -54 40 -101 89
-67 68 -86 93 -81 107 10 29 502 514 521 514 9 0 56 -41 105 -90z m-1010 -245
c10 -33 30 -83 43 -111 14 -28 25 -60 25 -70 0 -11 -61 -80 -151 -169 -196
-195 -239 -258 -274 -403 -10 -40 -21 -72 -26 -72 -18 0 -79 86 -100 143 -19
49 -24 80 -23 148 1 142 22 176 250 406 220 223 227 226 256 128z m1354 -98
c106 -108 138 -167 150 -278 7 -64 -13 -149 -53 -219 -26 -44 -281 -312 -316
-332 -16 -8 -48 19 -213 184 -124 123 -194 200 -194 213 0 13 88 108 247 267
189 189 254 248 272 248 18 0 48 -24 107 -83z m-1035 -332 c46 -47 86 -92 87
-101 2 -9 -57 -76 -145 -164 -168 -168 -180 -181 -211 -232 -24 -39 -72 -171
-72 -199 0 -9 -6 -22 -14 -28 -20 -16 -79 55 -106 128 -44 115 -34 235 26 339
31 54 314 342 336 342 8 0 53 -38 99 -85z m1436 -67 c68 -74 104 -207 83 -311
-21 -109 -43 -142 -199 -300 -80 -82 -154 -153 -164 -159 -16 -8 -33 5 -108
80 -70 69 -88 93 -83 108 4 11 81 94 171 186 89 91 163 174 163 182 0 9 4 16
8 16 14 0 72 158 72 198 0 15 6 22 18 22 10 0 28 -10 39 -22z m-981 -389 c104
-104 191 -191 192 -193 8 -10 -22 -44 -173 -199 -88 -89 -166 -171 -173 -182
-26 -42 -69 -141 -76 -176 -3 -20 -15 -44 -26 -54 -20 -18 -23 -15 -146 106
-106 104 -131 136 -162 199 -33 67 -36 83 -36 155 0 82 27 177 60 209 8 8 14
18 14 23 0 4 69 77 153 161 108 108 158 151 169 147 9 -4 101 -92 204 -196z
m1376 -46 c28 -57 31 -72 31 -156 0 -149 -19 -180 -251 -411 -129 -128 -195
-187 -207 -185 -12 3 -26 29 -44 84 -14 44 -36 96 -49 116 -12 20 -20 44 -16
52 3 8 78 89 167 179 174 176 219 242 252 371 7 31 17 62 20 68 10 16 62 -47
97 -118z m-931 -398 c46 -46 84 -91 84 -99 0 -8 -74 -90 -165 -183 -180 -183
-220 -241 -255 -375 -10 -38 -23 -68 -30 -68 -19 0 -60 52 -90 116 -26 53 -29
69 -29 159 1 146 23 186 218 382 83 84 158 153 167 153 9 0 54 -38 100 -85z
m257 -307 c30 -63 36 -134 17 -210 -22 -94 -30 -108 -109 -198 -73 -84 -151
-227 -165 -303 -5 -26 -12 -51 -16 -55 -9 -9 -60 51 -86 101 -65 125 -59 265
16 387 33 53 297 311 314 308 9 -2 22 -15 29 -30z"
      />
    </g>
  </svg>
);

export const DisconnectedIconRef = ({ id = "disconnected-id" }) => (
  <svg className="display-none" aria-hidden="true">
    <symbol id={id} viewBox="0 0 633 633">
      <path
        className="disconnected__hidden"
        d="M316.785 348.784c52.934 0 100.934 21.533 135.7 56.299l-45.232 45.234c-23.178-23.178-55.18-37.533-90.467-37.533-35.29 0-67.29 14.355-90.467 37.533l-45.234-45.234c34.764-34.766 82.764-56.299 135.7-56.299zm-226.275-34.274c60.44-60.44 140.799-93.726 226.274-93.726s165.834 33.286 226.274 93.726l-45.254 45.254c-48.354-48.353-112.641-74.98-181.02-74.98-68.381 0-132.667 26.628-181.02 74.98l-45.254-45.254zm400.666-186.507c53.352 22.566 101.26 54.864 142.393 95.998l-45.254 45.254c-72.529-72.528-168.961-112.471-271.53-112.471-102.57 0-199 39.943-271.529 112.471l-45.256-45.255c41.134-41.133 89.041-73.431 142.392-95.997 55.252-23.369 113.926-35.219 174.393-35.219 60.465 0 119.139 11.85 174.391 35.219zm-206.392 380.781c0 17.673 14.327 32 32 32 17.672 0 32-14.327 32-32s-14.328-32-32-32c-17.673 0-32 14.327-32 32z"
      ></path>
    </symbol>
  </svg>
);

export const DisconnectedAnimation = ({
  useId = "disconnected-id",
  type = "",
}) => (
  <svg className={`disconnected__icon  disconnected__${type}`}>
    <use xlinkHref={`#${useId}`}></use>
  </svg>
);

export const WebAuthn = () => (
  <>
    <Fingerprint />
    <USB />
  </>
);
export const Deploy = () => (
  <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g>
      {" "}
      <path d="M8.95305171,17.9846747 C8.72737466,19.1334216 7.71488744,20 6.5,20 L4.5,20 C4.22385763,20 4,19.7761424 4,19.5 L4,17.5 C4,16.2851126 4.86657841,15.2726253 6.0153253,15.0469483 L6.02714614,14.7041437 C6.04713299,14.1245251 6.10682628,13.555636 6.20352226,13 L2.5,13 C2.1462677,13 1.90438878,12.6427369 2.03576165,12.3143047 L4.03576165,7.31430466 C4.11169333,7.12447547 4.29554771,7 4.5,7 L9,7 C9.02538451,7 9.05032719,7.00189166 9.07469478,7.0055417 C11.4290981,4.32146349 14.9247139,2.67696313 18.771296,2.80960389 C19.3819666,2.8306615 19.9902263,2.89709634 20.5910446,3.008359 C20.7946429,3.04606238 20.9539376,3.20535713 20.991641,3.40895537 C21.812186,7.83989855 20.1522623,12.1558183 16.9947249,14.9271075 C16.9982004,14.9509022 17,14.9752409 17,15 L17,19.5 C17,19.7044523 16.8755245,19.8883067 16.6856953,19.9642383 L11.6856953,21.9642383 C11.3572631,22.0956112 11,21.8537323 11,21.5 L11,17.7949378 C10.4368132,17.8936903 9.86739064,17.9531458 9.29585627,17.9728539 L8.95305171,17.9846747 Z M7.98749247,17.6945992 L6.30540075,16.0125075 C5.56890748,16.1079151 5,16.7375198 5,17.5 L5,19 L6.5,19 C7.26248018,19 7.8920849,18.4310925 7.98749247,17.6945992 L7.98749247,17.6945992 Z M12,17.5770127 L12,20.7614835 L16,19.1614835 L16,15.7132231 C14.8178863,16.5520811 13.4713529,17.1925443 12,17.5770127 L12,17.5770127 Z M6.42079004,12 C6.80202391,10.5414825 7.44257093,9.19144113 8.28872675,8 L4.83851648,8 L3.23851648,12 L6.42079004,12 L6.42079004,12 Z M8.69991595,16.9928092 L9.26139399,16.9734479 C9.82252402,16.9540985 10.3814387,16.8930532 10.9335157,16.7908167 C16.9701904,15.672914 20.9957193,9.95997934 20.0664857,3.93363717 C19.626205,3.86599452 19.1822172,3.82436794 18.7368337,3.80900989 C12.4850041,3.59342956 7.24213247,8.48677642 7.02655214,14.738606 L7.00719083,15.300084 L8.69991595,16.9928092 Z M14,13 C12.3431458,13 11,11.6568542 11,10 C11,8.34314575 12.3431458,7 14,7 C15.6568542,7 17,8.34314575 17,10 C17,11.6568542 15.6568542,13 14,13 Z M14,12 C15.1045695,12 16,11.1045695 16,10 C16,8.8954305 15.1045695,8 14,8 C12.8954305,8 12,8.8954305 12,10 C12,11.1045695 12.8954305,12 14,12 Z"></path>{" "}
    </g>
  </svg>
);
